export default __webpack_public_path__ + "static/media/landingGif.212ab1a3.gif";